import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { CompetitionCatalog } from "../competitions/CompetitionCatalog";
import { HomeSection } from "./HomeSection";

export function CompetitionsSection() {
  return (
    <HomeSection
      id="competitions"
      title="Competitions"
      description="Bring your group together with sweeps and competitions for the big occasion."
    >
      <CompetitionCatalog limit={6} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button
          component={Link}
          to="/competitions"
          variant="outlined"
          size="large"
        >
          View all Competitions
        </Button>
      </Box>
    </HomeSection>
  );
}
